import { connect } from 'react-redux'

import { fetchForecasts } from '../../../modules/forecast'
import {
  addJob,
  getSortBy,
  getAddJobAddress,
  getAddJobLocation,
} from '../../../modules/job'
import { productActionCreators } from '../../../modules/product'

const mapStateToProps = (state) => ({
  sortBy: getSortBy(state),
  addJobAddress: getAddJobAddress(state),
  addJobLocation: getAddJobLocation(state),
})

const mapDispatchToProps = (dispatch) => ({
  dispatchGetProducts: () => dispatch(productActionCreators.getProducts.requested()),
  dispatchFetchForecasts: (productId) => dispatch(fetchForecasts.request(productId)),
  dispatchAddJob: (jobValues, sortBy) => dispatch(addJob.request(jobValues, sortBy)),
})

const redux = (Component) =>
  connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Component)

export { redux }
